<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { createEventDispatcher } from "svelte";
  import { t } from "svelte-i18n";

  export let error: Error | null = null;
  
  let isOpen: boolean = true;

  const dispatch = createEventDispatcher();
  
  function closeDialog() {
    isOpen = false;
    dispatch('close');
  }

  function onOpenChanged(open: boolean) {
    if( !open ) {
        dispatch('close');
    }
  }

</script>

{isOpen}
<Dialog.Root open={isOpen} onOpenChange={onOpenChanged}  >
  <Dialog.Content>
    <Dialog.Header>
      <Dialog.Title>{$t("global.messages.error-title")}</Dialog.Title>
    </Dialog.Header>
    <div class="text-red-500">
      <div>{error?.name}</div>
      <div>{error?.message}</div>
    </div>

    <Dialog.Footer class="flex pt-4">
      <Button class="px-8" on:click={closeDialog}>
        {$t("global.messages.ok")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
